import { LinesEditorComponent } from './../../../../components/lines-editor/lines-editor.component';
import { ColDef } from '@ag-grid-community/core';
import { AfterViewInit, Component, computed, inject, input, ViewChild } from '@angular/core';
import { FieldTypes } from '@digiwall/ag-grid';
import { LocalizationService } from '@abp/ng.core';
import { SupplierOrderDraftDto } from '@digiwall/goliath-documents/proxy';
import { DwFillHeightDirective } from '@digiwall/ui-kit';

@Component({
  selector: 'document-supplier-order-draft-grid',
  templateUrl: './supplier-order-draft-grid.component.html',
  imports: [LinesEditorComponent, DwFillHeightDirective],
})
export class SupplierOrderDraftGridComponent implements AfterViewInit {
  private localizationService = inject(LocalizationService);

  @ViewChild('lineGrid') lineGrid: LinesEditorComponent;

  public supplierOrderDrafts = input<SupplierOrderDraftDto[]>();

  protected lines = computed(() => {
    return this.supplierOrderDrafts().flatMap((supplierOrder, supplierOrderIndex) => {
      const supplierOrderReference = `${supplierOrderIndex + 1}`;

      const lines = [
        {
          id: supplierOrder.id,
          supplierOrder: supplierOrder.displayNumber,
          supplierCode: supplierOrder.supplierCode,
          displayReference: supplierOrderReference,
          articleCode: '',
          description: `${supplierOrder.supplierCode} ${supplierOrder.displayNumber != null ? '- ' + supplierOrder.displayNumber : ''}`,
        },
      ];

      lines.push(
        ...supplierOrder.articleLines.map((line, lineIndex) => {
          return {
            id: line.id,
            supplierOrder: null,
            supplierCode: null,
            displayReference: `${supplierOrderReference}.${lineIndex + 1}`,
            articleCode: line.articleCode,
            quantity: line.quantity,
            description: line.description,
            articleRange1: line.articleRange1,
            articleRangeValue1: line.articleRangeValue1,
            articleRange2: line.articleRange2,
            articleRangeValue2: line.articleRangeValue2,
            articleBatch: line.articleBatch,
          };
        }),
      );
      return lines;
    });
  });

  protected columnDefs: ColDef[] = [
    {
      field: 'displayReference',
      headerName: '#',
      type: FieldTypes.String,
      width: 70,
      suppressNavigable: true,
      suppressHeaderMenuButton: true,
      sort: 'asc',
      pinned: 'left',
      suppressMovable: true,
      suppressAutoSize: true,
    },
    {
      field: 'articleCode',
      headerName: this.localizationService.instant('Product::Article:Code'),
    },
    {
      field: 'description',
      headerName: this.localizationService.instant('GoliathCore::Description'),
    },
    {
      field: 'supplierOrder',
      headerName: this.localizationService.instant('Doc::OpenOrderLines:OrderDisplayNumber'),
    },
    {
      field: 'quantity',
      headerName: this.localizationService.instant('::Quantity'),
    },
    {
      field: 'articleRange1',
      headerName: this.localizationService.instant('Doc::StockDoc:ArticleRange1'),
    },
    {
      field: 'articleRangeValue1',
      headerName: this.localizationService.instant('Doc::StockDoc:ArticleRangeValue1'),
    },
    {
      field: 'articleRange2',
      headerName: this.localizationService.instant('Doc::StockDoc:ArticleRange2'),
    },
    {
      field: 'articleRangeValue2',
      headerName: this.localizationService.instant('Doc::StockDoc:ArticleRangeValue2'),
    },
    {
      field: 'articleBatch',
      headerName: this.localizationService.instant('Doc::StockDoc:ArticleLot'),
    },
  ];

  ngAfterViewInit(): void {
    this.lineGrid.grid.grid.api.setGridOption('rowSelection', {
      mode: 'singleRow',
      enableSelectionWithoutKeys: false,
      checkboxes: false,
    });
  }

  getContextMenuItems = _ => [];

  protected rowClassRules = {
    'chapter-line': params => {
      const line = params.node.data;
      if (line == null) return false;
      return line.supplierCode != null;
    },
    'ag-row-disabled': params => false,
  };
}
